/* VYBE 3D tin viewer — progressive enhancement only.
   If this never runs (no JS/WebGL), the CSS swinging tin stays visible.
   Config comes from window.VYBE3D = { engine: <asset url>, tex: {key: {face,back,side}} } */
(async function () {
  try {
    var cfg = window.VYBE3D;
    var container = document.getElementById('tin3d');
    var stage = document.querySelector('.tin-stage');
    if (!cfg || !container || !stage) return;

    const THREE = await import(cfg.engine);

    const renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    renderer.outputColorSpace = THREE.SRGBColorSpace;

    const scene = new THREE.Scene();
    const camera = new THREE.PerspectiveCamera(38, 1, 0.1, 100);
    camera.position.set(0, 0.06, 3.6);

    scene.add(new THREE.AmbientLight(0xffffff, 1.1));
    const keyLight = new THREE.DirectionalLight(0xffffff, 2.0);
    keyLight.position.set(3, 4, 5);
    scene.add(keyLight);
    const fillLight = new THREE.DirectionalLight(0xffffff, 0.5);
    fillLight.position.set(-4, 1.5, 2);
    scene.add(fillLight);

    const RIMS = { 'spearmint': 0x9BE87F, 'blue-rasp': 0x82C7F0, 'fruit-punch': 0xF09090,
                   'gummy-bear': 0xF0B482, 'peach-rings': 0xF0A0C8, 'pineapple': 0xF0DC8C };
    const RADIO_TO_KEY = { 'fv-sp': 'spearmint', 'fv-br': 'blue-rasp', 'fv-fp': 'fruit-punch',
                           'fv-gb': 'gummy-bear', 'fv-pr': 'peach-rings', 'fv-pm': 'pineapple' };

    const loader = new THREE.TextureLoader();
    const texCache = {};
    let texFailed = false;
    function onTexError() { if (!texFailed) { texFailed = true; stage.classList.remove('has-3d'); } }
    function loadSet(key) {
      if (!texCache[key]) {
        const urls = cfg.tex[key];
        texCache[key] = ['face', 'back', 'side'].map(function (kind) {
          const t = loader.load(urls[kind], undefined, undefined, onTexError);
          t.colorSpace = THREE.SRGBColorSpace;
          t.anisotropy = 8;
          if (kind === 'side') { t.wrapS = THREE.RepeatWrapping; t.wrapT = THREE.ClampToEdgeWrapping; }
          return t;
        });
      }
      return texCache[key];
    }

    const group = new THREE.Group();
    scene.add(group);

    const radius = 1.08, depth = 0.30, segments = 192;
    const verts = [], uvs = [], indices = [];
    for (let i = 0; i <= segments; i++) {
      const a = (i / segments) * Math.PI * 2;
      const x = Math.cos(a) * radius, y = Math.sin(a) * radius;
      verts.push(x, y, -depth / 2, x, y, depth / 2);
      uvs.push(1 - i / segments, 1, 1 - i / segments, 0);
    }
    for (let i = 0; i < segments; i++) {
      const b = i * 2;
      indices.push(b, b + 2, b + 1, b + 1, b + 2, b + 3);
    }
    const sideGeometry = new THREE.BufferGeometry();
    sideGeometry.setAttribute('position', new THREE.Float32BufferAttribute(verts, 3));
    sideGeometry.setAttribute('uv', new THREE.Float32BufferAttribute(uvs, 2));
    sideGeometry.setIndex(indices);
    sideGeometry.computeVertexNormals();

    const sideMaterial = new THREE.MeshStandardMaterial({ roughness: 0.58, metalness: 0.08 });
    const frontMaterial = new THREE.MeshStandardMaterial({ roughness: 0.5, metalness: 0.04 });
    const backMaterial = new THREE.MeshStandardMaterial({ roughness: 0.5, metalness: 0.04 });
    const rimMaterial = new THREE.MeshStandardMaterial({ roughness: 0.38, metalness: 0.34 });

    group.add(new THREE.Mesh(sideGeometry, sideMaterial));
    const frontDisk = new THREE.Mesh(new THREE.CircleGeometry(radius * 0.985, segments), frontMaterial);
    frontDisk.position.z = depth / 2 + 0.002;
    group.add(frontDisk);
    const backDisk = new THREE.Mesh(new THREE.CircleGeometry(radius * 0.985, segments), backMaterial);
    backDisk.position.z = -depth / 2 - 0.002;
    backDisk.rotation.y = Math.PI;
    group.add(backDisk);
    const frontRim = new THREE.Mesh(new THREE.TorusGeometry(radius, 0.02, 12, segments), rimMaterial);
    frontRim.position.z = depth / 2 + 0.006;
    group.add(frontRim);
    const backRim = new THREE.Mesh(new THREE.TorusGeometry(radius, 0.02, 12, segments), rimMaterial);
    backRim.position.z = -depth / 2 - 0.006;
    group.add(backRim);

    function applyFlavour(id) {
      const key = RADIO_TO_KEY[id];
      if (!key || !cfg.tex[key]) return;
      const set = loadSet(key);
      frontMaterial.map = set[0]; backMaterial.map = set[1]; sideMaterial.map = set[2];
      frontMaterial.needsUpdate = backMaterial.needsUpdate = sideMaterial.needsUpdate = true;
      rimMaterial.color.setHex(RIMS[key]);
      group.rotation.x = -0.10;   /* present each newly selected tin face-first */
      group.rotation.y = -0.35;
    }

    const radios = document.querySelectorAll('input[name=flav]');
    radios.forEach(function (r) { r.addEventListener('change', function () { applyFlavour(r.id); }); });
    const checked = document.querySelector('input[name=flav]:checked');
    applyFlavour(checked ? checked.id : 'fv-sp');

    group.rotation.x = -0.10;
    group.rotation.y = -0.35;

    let dragging = false, lastX = 0, lastY = 0;
    container.addEventListener('pointerdown', function (e) {
      dragging = true; lastX = e.clientX; lastY = e.clientY;
      container.setPointerCapture(e.pointerId);
    });
    container.addEventListener('pointerup', function (e) { dragging = false; container.releasePointerCapture(e.pointerId); });
    container.addEventListener('pointercancel', function () { dragging = false; });
    container.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      group.rotation.y += (e.clientX - lastX) * 0.012;
      group.rotation.x += (e.clientY - lastY) * 0.006;
      group.rotation.x = Math.max(-0.65, Math.min(0.65, group.rotation.x));
      lastX = e.clientX; lastY = e.clientY;
    });

    const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;

    function resize() {
      const w = container.clientWidth, h = container.clientHeight;
      camera.aspect = w / h;
      camera.updateProjectionMatrix();
      renderer.setSize(w, h);
    }
    window.addEventListener('resize', resize);

    function animate() {
      requestAnimationFrame(animate);
      if (!dragging && !reduceMotion) group.rotation.y += 0.003;
      renderer.render(scene, camera);
    }

    container.appendChild(renderer.domElement);
    stage.classList.add('has-3d');
    resize();
    animate();
  } catch (err) {
    /* CSS tin fallback stays — nothing to do */
  }
})();
